import { createContext } from "react";

export type GetCustomFieldOptions = (
  fieldId: string,
) => Promise<{ name: string; options: { id: string; name: string }[] }>;

export const CustomFieldContext = createContext<
  GetCustomFieldOptions | undefined
>(undefined);

export function CustomFieldProvider({
  children,
  getCustomFieldOptions,
}: {
  children: React.ReactNode;
  getCustomFieldOptions: GetCustomFieldOptions;
}) {
  return (
    <CustomFieldContext.Provider value={getCustomFieldOptions}>
      {children}
    </CustomFieldContext.Provider>
  );
}
